<template>
<div v-cloak>
  <h1 class="push-double--top push-half--bottom text--center">
    <img src="/assets/img/crm-logo.png" alt="DRMG CRM" style="width: 32px; vertical-align: top; position: relative; top: -2px;" />
    {{ $_('drmg_crm') }}
  </h1>
  <div class="sync-line" style=""><i class="fa fa-refresh" style=""></i></div>
  <div class="card card--large push-double--bottom">
    <form class="form" v-on:submit.prevent="login()" v-if="!user.token">
      <h3 class="push-half--bottom">{{ $_('crm_login_info') }}</h3>
      <p class="milli" style="line-height: 1.5;" v-html="$_('crm_login_note')"></p>
      <div class="grid">
        <div class="grid__item one-third2 portable--one-whole">
          <div class="form__line">
            <div class="form__field flush--bottom">
              <label for="merge_with">{{ $_('crm_username') }}</label>
              <input type="text" name="username" id="username" class="field field--select" v-model="user.username" />
            </div>
          </div>
          <div class="form__line">
            <div class="form__field flush--bottom">
              <label for="merge_with">{{ $_('crm_password') }}</label>
              <input type="password" name="password" id="password" class="field field--select" v-model="user.password" />
            </div>
          </div>
          <div class="form__line flush--bottom flush--bottom">
            <button type="submit" class="button button--primary" :disabled="!user.username || !user.password || loading" @click="login()">{{ $_('login') }} <i class="fa fa-spin fa-spinner" v-if="loading"></i></button>
          </div>
        </div>
      </div>
      <div class="form__line flush--bottom push--top" v-if="err.length">
        <div class="form__field">
          <div class="parsley-error" v-for="error in err" v-bind:key="error">{{ error }}</div>
        </div>
      </div>
    </form>
    <div v-if="user.token">
      <p>{{ $_('logged_in_as') }} <strong>{{ user.username }}</strong>.</p>
      <button type="button" class="button button--primary" @click="logout()">{{ $_('log_out') }}</button>
    </div>
  </div>
</div>
</template>

<script>
import CRM from './CRM.js'

export default {
  mixins: [CRM],
  data () {
    return {
      err: [],
      loading: false,
    }
  },
  methods: {
    login() {
      this.loading = true;
      this.CRM_login(this.user.username, this.user.password).then(response => {
        if (response) {
          this.CRM_save(response.data);
          if (window.location.href !== document.referrer) window.location.replace(document.referrer);
        }
        this.loading = false;
      }, error => {
        var m = (error.response.status === 401 || error.response.status === 404) ? this.$_('wrong_username_password') : this.$_('there_was_error');
        console.error(error.message);
        this.err = [m];
        this.loading = false;
      });
    },
    logout() {
      this.CRM_logout();
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../../css/vars';
.sync-line {
  position: relative;
  margin-bottom: $spacing-half;
  text-align: center;
  color: $color-primary;
  font-size: $h1-size;

  &:before,
  &:after {
    content: '';
    position: absolute;
    top: 50%;
    width: 40%;
    border-top: 1px solid $color-primary;
  }
  &:before {
    left: 0;
  }
  &:after {
    right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/CrmAuth.vue